module.exports = __webpack_public_path__ + "img/6.d91d67c0.png";